(function (root) {
  "use strict";

  var CONTRACT = "wynch.article-club-doi-return.v2";
  var CONTRACT_VERSION = "2.0.0";
  var STORAGE_KEY = "wynch_article_club_doi_pending_v1";
  var MAX_AGE_MS = 48 * 60 * 60 * 1000;
  var BLOCK_ID_PATTERN = /^[A-Za-z][A-Za-z0-9_-]{0,119}$/;

  function fail(code) { throw new Error(code); }
  function record(value, code) {
    if (!value || typeof value !== "object" || Array.isArray(value)) fail(code);
    return value;
  }
  function exactKeys(value, expected, code) {
    var actual = Object.keys(value).sort();
    var sorted = expected.slice().sort();
    if (actual.length !== sorted.length || actual.some(function (key, index) { return key !== sorted[index]; })) fail(code);
  }
  function blockId(value) {
    if (typeof value !== "string" || !BLOCK_ID_PATTERN.test(value)) fail("ARTICLE_CLUB_DOI_BLOCK_ID_INVALID_V1");
    return value;
  }
  function sessionId(value) {
    if (typeof value !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)) fail("ARTICLE_CLUB_DOI_SESSION_ID_INVALID_V2");
    return value;
  }
  function returnPath(value) {
    if (typeof value !== "string" || value.length < 1 || value.length > 2000 || value.charAt(0) !== "/" || value.slice(0, 2) === "//" || /[\u0000-\u001f]/.test(value)) {
      fail("ARTICLE_CLUB_DOI_RETURN_PATH_INVALID_V1");
    }
    return value;
  }

  function buildReturnPath(currentHref, storefrontOrigin, targetBlockId) {
    var origin = new URL(storefrontOrigin).origin;
    var current = new URL(currentHref, origin);
    if (current.origin !== origin) fail("ARTICLE_CLUB_DOI_RETURN_ORIGIN_INVALID_V1");
    current.searchParams.delete("wynch_club");
    current.hash = blockId(targetBlockId);
    return returnPath(current.pathname + current.search + current.hash);
  }

  function createPendingReceipt(input) {
    var source = record(input, "ARTICLE_CLUB_DOI_RECEIPT_OBJECT_REQUIRED_V1");
    exactKeys(source, ["blockId", "returnPath", "sessionId", "createdAt"], "ARTICLE_CLUB_DOI_RECEIPT_INPUT_EXACT_KEYS_REQUIRED_V2");
    if (!Number.isInteger(source.createdAt) || source.createdAt < 0) fail("ARTICLE_CLUB_DOI_CREATED_AT_INVALID_V1");
    return Object.freeze({
      contract: CONTRACT,
      contractVersion: CONTRACT_VERSION,
      status: "pending",
      blockId: blockId(source.blockId),
      returnPath: returnPath(source.returnPath),
      sessionId: sessionId(source.sessionId),
      createdAt: source.createdAt
    });
  }

  function parsePendingReceipt(value, now) {
    var source = typeof value === "string" ? JSON.parse(value) : value;
    source = record(source, "ARTICLE_CLUB_DOI_RECEIPT_OBJECT_REQUIRED_V1");
    exactKeys(source, ["contract", "contractVersion", "status", "blockId", "returnPath", "sessionId", "createdAt"], "ARTICLE_CLUB_DOI_RECEIPT_EXACT_KEYS_REQUIRED_V2");
    if (source.contract !== CONTRACT || source.contractVersion !== CONTRACT_VERSION || source.status !== "pending") fail("ARTICLE_CLUB_DOI_RECEIPT_CONTRACT_INVALID_V1");
    if (!Number.isInteger(now) || now < 0 || !Number.isInteger(source.createdAt) || source.createdAt < 0 || source.createdAt > now || now - source.createdAt > MAX_AGE_MS) {
      fail("ARTICLE_CLUB_DOI_RECEIPT_STALE_V1");
    }
    return Object.freeze({
      contract: CONTRACT,
      contractVersion: CONTRACT_VERSION,
      status: "pending",
      blockId: blockId(source.blockId),
      returnPath: returnPath(source.returnPath),
      sessionId: sessionId(source.sessionId),
      createdAt: source.createdAt
    });
  }

  function readPendingReceipt(storage, now) {
    try {
      var serialized = storage.getItem(STORAGE_KEY);
      if (!serialized) return null;
      return parsePendingReceipt(serialized, now);
    } catch (error) {
      try { storage.removeItem(STORAGE_KEY); } catch (ignored) {}
      return null;
    }
  }

  function savePendingReceipt(storage, receipt) {
    var parsed = parsePendingReceipt(receipt, receipt.createdAt);
    storage.setItem(STORAGE_KEY, JSON.stringify(parsed));
    return parsed;
  }

  function clearPendingReceipt(storage) { storage.removeItem(STORAGE_KEY); }

  function buildConfirmedDestination(storefrontOrigin, receipt, now) {
    var origin = new URL(storefrontOrigin).origin;
    var parsed = parsePendingReceipt(receipt, now);
    var destination = new URL(parsed.returnPath, origin);
    if (destination.origin !== origin) fail("ARTICLE_CLUB_DOI_RETURN_ORIGIN_INVALID_V1");
    destination.searchParams.set("wynch_club", "confirmed");
    destination.hash = parsed.blockId;
    return destination.toString();
  }

  function hasReturnMarker(href, storefrontOrigin) {
    var origin = new URL(storefrontOrigin).origin;
    var target = new URL(href, origin);
    if (target.origin !== origin) return false;
    var values = target.searchParams.getAll("wynch_club");
    return values.length === 1 && values[0] === "confirmed";
  }

  function resolveUiState(input) {
    var source = record(input, "ARTICLE_CLUB_DOI_UI_STATE_OBJECT_REQUIRED_V1");
    exactKeys(source, ["returnMarker", "pendingReceipt", "verifiedState", "now"], "ARTICLE_CLUB_DOI_UI_STATE_EXACT_KEYS_REQUIRED_V1");
    if (typeof source.returnMarker !== "boolean") fail("ARTICLE_CLUB_DOI_RETURN_MARKER_INVALID_V1");
    if (!Number.isInteger(source.now) || source.now < 0) fail("ARTICLE_CLUB_DOI_NOW_INVALID_V1");
    if (source.pendingReceipt !== null) parsePendingReceipt(source.pendingReceipt, source.now);
    if (["confirmed", "pending", "unavailable"].indexOf(source.verifiedState) === -1) fail("ARTICLE_CLUB_DOI_VERIFIED_STATE_INVALID_V1");
    if (source.verifiedState === "confirmed") return "success";
    if (source.returnMarker) return "verification_required";
    if (source.pendingReceipt) return "waiting";
    return "idle";
  }

  function installThemeAppBridge() {
    if (typeof window === "undefined" || typeof document === "undefined") return;
    document.addEventListener("wynch:article-club-native", function (event) {
      var detail = event && event.detail;
      if (!detail || detail.contract !== "wynch.shopify-klaviyo-article-club.v2" || detail.event !== "native-club-state") return;
      if (detail.state === "confirmed" || detail.state === "signup") {
        try { clearPendingReceipt(window.localStorage); } catch (error) {}
        return;
      }
      if (detail.state !== "pending") return;
      try {
        var node = document.querySelector("[data-wynch-article-club-native]");
        var token = window.localStorage.getItem("wynch_article_club_continuation_v2") || "";
        if (!node || !token) return;
        var current = new URL(window.location.href);
        current.searchParams.delete("wynch_club");
        savePendingReceipt(window.localStorage, createPendingReceipt({
          blockId: node.id,
          returnPath: buildReturnPath(current.toString(), window.location.origin, node.id),
          sessionId: token,
          createdAt: Date.now()
        }));
      } catch (error) {}
    });
  }

  root.WynchArticleClubDoiReturnV1 = Object.freeze({
    CONTRACT: CONTRACT,
    CONTRACT_VERSION: CONTRACT_VERSION,
    STORAGE_KEY: STORAGE_KEY,
    MAX_AGE_MS: MAX_AGE_MS,
    buildReturnPath: buildReturnPath,
    createPendingReceipt: createPendingReceipt,
    parsePendingReceipt: parsePendingReceipt,
    readPendingReceipt: readPendingReceipt,
    savePendingReceipt: savePendingReceipt,
    clearPendingReceipt: clearPendingReceipt,
    buildConfirmedDestination: buildConfirmedDestination,
    hasReturnMarker: hasReturnMarker,
    resolveUiState: resolveUiState
  });
  installThemeAppBridge();
})(typeof window !== "undefined" ? window : globalThis);
